// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bhl_ss","PhotoTitleEditForm__cancelBtn":"iy_b bhl_sw bhl_sv"};